@import '../../sass/helpers';
@import '../../sass/mixins/buttons';

// This is so the button height is correctly calculated in som-popover
som-button {
  display: inline-block;
}

.som-drp-popover-content {
  padding: 1rem;
}

.som-drp-inputs-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0.625rem;

  .som-dpm-input-arrow {
    width: 3.125rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $navy;
  }

  input {
    display: inline-block;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    border-radius: 0;
    padding: 0.5rem;
    width: 8.25rem;
    height: 2rem;
    text-align: center;

    &::placeholder {
      font-size: 0.9rem;
      color: #999;
    }

    &::-ms-clear {
      display: none;
    }
  }
}

// TODO: This can be removed I think
.som-drp-button {
  display: flex !important;
  flex-direction: row;
  align-items: center;

  .som-drp-button-arrow {
    height: 1rem;
    position: relative;
    top: -3px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;    
  }
}

som-button {
  .som-drp-button-arrow {
    position: relative;
    padding-left: 0.5rem;
    padding-right: 0.5rem;    
  }
}

.som-drp-button-actions {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.5rem;
  padding-bottom: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 1rem;
  border-top: 1px solid $border-color;

  button {
    border: none;
    background: transparent;    
    @include font-weight(700)
  }

  &__clear {
    color: $header-copy;

    &:hover {
      color: map-get($button-hover-colors, 'ash');
      text-decoration: $link-hover-decoration;
      background-color: transparent;
      border-color: transparent;
    }
  
    &:focus,
    &.focus {
      color: map-get($button-hover-colors, 'ash');
      outline: none;
      box-shadow: 0px 0px 0px 2px map-get($button-focus-colors, 'ash');
      //box-shadow: 0px 0px 0px 2px $value;
      text-decoration: $link-hover-decoration;
      border-color: transparent;
    }
  }

  &__apply {
    color: $primary;

    &:hover {
      color: map-get($button-hover-colors, 'primary');
      text-decoration: $link-hover-decoration;
      background-color: transparent;
      border-color: transparent;
    }
  
    &:focus,
    &.focus {
      color: map-get($button-hover-colors, 'primary');
      outline: none;
      box-shadow: 0px 0px 0px 2px map-get($button-focus-colors, 'primary');
      //box-shadow: 0px 0px 0px 2px $value;
      text-decoration: $link-hover-decoration;
      border-color: transparent;
    }    
  }
}
